/** 短音效资源。合成 WAV 见 scripts/gen-sfx.mjs，美术到位后只换文件即可。 */
export const SFX = {
  tap: "assets/sfx-tap.wav",
  key: "assets/sfx-key.wav",
  start: "assets/sfx-start.wav",
  turn: "assets/sfx-turn.wav",
  hint: "assets/sfx-hint.wav",
  tick: "assets/sfx-tick.wav",
  success: "assets/sfx-success.wav",
  miss: "assets/sfx-miss.wav",
  timeout: "assets/sfx-timeout.wav",
  win: "assets/sfx-win.wav",
  lose: "assets/sfx-lose.wav",
} as const;

export type SfxId = keyof typeof SFX;
